import { DeviceType, type TailwindBreakpoint } from "@/utils/styleUtils";

/**
 * @deprecated Prefer TailwindCSS or CSS media query instead
 */
export const useScreenSize = () => {
  const viewport = useViewport();

  const isMinimumMd = computed(() => viewport.isGreaterOrEquals("md"));
  const isMinimumLg = computed(() => viewport.isGreaterOrEquals("lg"));
  const isMinimumXl = computed(() => viewport.isGreaterOrEquals("xl"));

  const isMobile = computed(() => !isMinimumMd.value);

  const isTablet = computed(
    () => viewport.isGreaterOrEquals("md") && viewport.isLessThan("lg"),
  );

  const isDesktop = computed(() => viewport.isGreaterOrEquals("lg"));

  const currentBreakpoint = computed(
    () => viewport.breakpoint.value as TailwindBreakpoint,
  );

  const deviceType = computed(() => {
    if (isDesktop.value) {
      return DeviceType.desktop;
    }

    if (isTablet.value) {
      return DeviceType.tablet;
    }

    return DeviceType.mobile;
  });

  return {
    isMinimumMd,
    isMinimumLg,
    isMinimumXl,
    isMobile,
    currentBreakpoint,
    deviceType,
  };
};
